exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".my-attended-lectures-template[data-v-5605b672]{min-height:100px;margin-top:-35px}", ""]);

